module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_14-696cc435514f02029344a8a98fc66892.jpg";